import { IconButton } from '@creditornot/cb-button';
import { Cross } from '@creditornot/cb-icons';
import { cssThemedValue, typographyCss } from '@creditornot/cb-ingredients';
import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { OFFER_FILTER_OPTION_LABELS } from 'modules/shared-menu/components/FilterMenu/constants';
import { SelectableOfferFilterId } from 'modules/shared-menu/components/FilterMenu/types';
import { SelectedKeyValues } from 'modules/shared-menu/components/SelectableAccordion';

type FilterTagsRowProps = {
  onRemoveClick: ({ groupId, optionId }: { groupId: string; optionId: string }) => void;
  onClearAll: () => void;
  selectedFiltersByGroup: SelectedKeyValues<SelectableOfferFilterId>;
};

const Root = styled.div`
  display: flex;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
  padding: 12px 24px;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${typographyCss.Body3}
`;

const TagsContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const RemoveTagsIcon = styled(Cross)``;

export const FilterTagsRow = ({ onRemoveClick, selectedFiltersByGroup, onClearAll }: FilterTagsRowProps) => {
  return (
    <Root>
      <TagsContainer>
        <span>
          <FormattedMessage id="shared-menu.editor.filter-menu.filter-result-header" />
        </span>
        {Object.keys(selectedFiltersByGroup).map(groupId =>
          Object.values(selectedFiltersByGroup[groupId]).map(optionId => (
            <Tag
              size="small"
              variant="lightBlue"
              iconPosition="left"
              onRemoveClick={() => onRemoveClick({ groupId, optionId })}
              key={`${groupId}-${optionId}`}
            >
              <FormattedMessage id={OFFER_FILTER_OPTION_LABELS?.[optionId]} />
            </Tag>
          )),
        )}
      </TagsContainer>
      <IconButton size="tiny" variant="grey" background="static" alignment="boundingBox" onClick={onClearAll}>
        <RemoveTagsIcon />
      </IconButton>
    </Root>
  );
};
